/** @format */

const ADD_SVG_TO_STORE = 'ADD_SVG_TO_STORE';
const LOADING_SVG = 'LOADING_SVG';

export default {
  ADD_SVG_TO_STORE,
  LOADING_SVG,
};
